import React from 'react';
import { Modal, ModalBody, ModalHeader, ModalProps } from 'reactstrap';
import { CreateTaskRequest } from 'src/api/services/TaskClient';
import { useTranslation } from 'react-i18next';
import { CreateTaskForm } from './TaskForm/CreateTaskForm';
import { FormikHelpers } from 'formik';

type Props = Omit<ModalProps, 'toggle'> & {
  toggle: () => void;
  onSubmit: (values: CreateTaskRequest, helpers: FormikHelpers<CreateTaskRequest>) => Promise<void>;
};

const CreateTaskModal: React.FC<Props> = ({ toggle, onSubmit, ...props }) => {
  const { t } = useTranslation('actions');

  const handleSubmit: Props['onSubmit'] = async (...args) => {
    await onSubmit(...args);
    toggle();
  };

  return (
    <Modal {...props} toggle={toggle}>
      <ModalHeader toggle={toggle}>{t('create_note')}</ModalHeader>
      <ModalBody>
        <CreateTaskForm onSubmit={handleSubmit} />
      </ModalBody>
    </Modal>
  );
};

export type { Props as TaskFormModalProps };
export { CreateTaskModal };
